import { render, staticRenderFns } from "./tcs.vue?vue&type=template&id=2f0ef081&scoped=true&"
import script from "./tcs.vue?vue&type=script&lang=js&"
export * from "./tcs.vue?vue&type=script&lang=js&"
import style0 from "./tcs.vue?vue&type=style&index=0&id=2f0ef081&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0ef081",
  null
  
)

export default component.exports